import { useRef } from "react";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "../components/ui/carousel";

const PROJECTS = [
  {
    image: "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/dthgqrbl_IMG_8304.jpeg",
    title: "Installation PAC Air/Eau Panasonic",
    location: "Bias (47)",
  },
  {
    image: "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/uhc3iazg_cd0b680f-bc02-4c29-8d08-7f3b72945eee.jpeg",
    title: "PAC Air/Eau Panasonic R32",
    location: "Villeneuve-sur-Lot (47)",
  },
  {
    image: "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/dazqjsv5_4392195406607805412.jpeg",
    title: "Installation interieure PAC Air/Eau",
    location: "Penne-d'Agenais (47)",
  },
  {
    image: "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/wxy6fiis_b64832ea-6898-4068-aa27-e20882bbf8d5.jpeg",
    title: "PAC Air/Air Panasonic R32",
    location: "Casseneuil (47)",
  },
  {
    image: "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/dfysbwq1_8657dc97-3334-4cef-b630-891d731a1159.jpeg",
    title: "Installation PAC Panasonic",
    location: "Monflanquin (47)",
  },
];

export default function RealizationsSection() {
  const autoplayPlugin = useRef(
    Autoplay({ delay: 4000, stopOnInteraction: true, stopOnMouseEnter: true })
  );

  return (
    <section
      id="realisations"
      data-testid="realisations-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14 scroll-reveal">
          <h2
            className="text-3xl md:text-4xl font-bold tracking-tight text-[#6AB023] mb-4"
            data-testid="realisations-title"
          >
            Nos realisations
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Nos installations recentes de pompe a chaleur et climatisation en Lot-et-Garonne.
          </p>
        </div>

        <div className="scroll-reveal px-4 md:px-12">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            plugins={[autoplayPlugin.current]}
            className="w-full"
            data-testid="realisations-carousel"
          >
            <CarouselContent className="-ml-4 md:-ml-6">
              {PROJECTS.map((project, idx) => (
                <CarouselItem
                  key={project.title}
                  className="pl-4 md:pl-6 basis-[85%] sm:basis-[60%] md:basis-[45%] lg:basis-[33.333%]"
                >
                  <div
                    className="group relative bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-lg transition-all h-full"
                    data-testid={`realization-${idx}`}
                  >
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={project.image}
                        alt={`${project.title} - ${project.location}`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <h3 className="text-base font-bold text-gray-900 mb-1">{project.title}</h3>
                      <p className="text-xs font-medium text-[#6AB023]">{project.location}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="-left-3 md:-left-5 bg-white border-gray-200 hover:bg-green-50 hover:border-[#6AB023]" />
            <CarouselNext className="-right-3 md:-right-5 bg-white border-gray-200 hover:bg-green-50 hover:border-[#6AB023]" />
          </Carousel>
        </div>
      </div>
    </section>
  );
}
